module.exports = __webpack_public_path__ + "static/img/vimg4.a07ad78.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/vimg4.jpg
// module id = 1b6t
// module chunks = 0